(() => {
  if (window.__ttPdpQtyDefault) return;
  window.__ttPdpQtyDefault = true;

  const ATTR = 'data-tt-default-qty';

  function applyDefault(input) {
    if (!input || !input.hasAttribute(ATTR)) return;
    const desired = Number.parseInt(input.getAttribute(ATTR), 10);
    if (!desired || desired < 1) return;
    const min = Number.parseInt(input.min || input.getAttribute('data-min') || '1', 10) || 1;
    const maxRaw = input.max || input.getAttribute('data-max');
    const max = maxRaw === '' || maxRaw == null ? null : Number.parseInt(maxRaw, 10);
    let next = Math.max(min, desired);
    if (max != null && !Number.isNaN(max)) next = Math.min(next, max);
    if (String(input.value) !== String(next)) input.value = String(next);
  }

  function wrapQuantityInput() {
    const Ctor = customElements.get('quantity-input');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__ttQtyDefaultWrap) return;
    const orig = Ctor.prototype.setQuantityBoundaries;
    if (typeof orig !== 'function') return;
    Ctor.prototype.setQuantityBoundaries = function setQuantityBoundariesWrapped() {
      orig.apply(this, arguments);
      applyDefault(this.input || this.querySelector('input[name="quantity"]'));
    };
    Ctor.prototype.__ttQtyDefaultWrap = true;
    document.querySelectorAll('input[' + ATTR + ']').forEach(applyDefault);
  }

  if (customElements.get('quantity-input')) wrapQuantityInput();
  else customElements.whenDefined('quantity-input').then(wrapQuantityInput);
})();
